document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


  //SEC 1
  gsap.set('.co-process-s1 .z-ani-o', { opacity: 0, y: 40 });
  let cPS1Tl1 = gsap.timeline({ paused: true });
  cPS1Tl1.to('.co-process-s1 .z-ani-o', {
    y: 0,
    scale: 1,
    opacity: 1,
    duration: 1,
    stagger: 0.2,
    ease: "power2.inOut"
  }, "-=0.9");
  ScrollTrigger.create({
    trigger: '.co-process-s1 .z-ani-o',
    start: "40% bottom",
    end: "bottom top",
    animation: cPS1Tl1
  });

  //SEC 2

  gsap.set('.co-process-s2 .z-ani-o', { opacity: 0, y: 40 });
  gsap.set('.co-process-s2-section .co-process-s2-section--image', { opacity: 0, y: 20, x: 5 });
  let cPS2Tl1 = gsap.timeline({ paused: true });
  cPS2Tl1.to('.co-process-s2-section .co-process-s2-section--image', {
    y: 0,
    x: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut"
  });
  cPS2Tl1.to('.co-process-s2 .z-ani-o', {
    y: 0,
    scale: 1,
    opacity: 1,
    duration: 1,
    stagger: 0.2,
    ease: "power2.inOut"
  }, "-=0.9");
  ScrollTrigger.create({
    trigger: '.co-process-s2 .z-ani-o',
    start: "40% bottom",
    end: "bottom top",
    animation: cPS2Tl1
  });
  initCards();

  const coAnchorBtns = document.querySelectorAll('.co-process-s2--anchors a');
  const coAnchorSections = gsap.utils.toArray('.co-process-s2-section');

  coAnchorBtns.forEach(function (coAnchorBtn, index) {
    coAnchorBtn.addEventListener('click', (e) => {
      e.preventDefault();
      gsap.to(window, {
        scrollTo: coAnchorSections[index],
        duration: 1,
        ease: "power2.inOut",
      });
    });
  });

  const PS26S = new Swiper('.co-process-s2-s6-swiper', {
    pagination: {
      el: '.co-process-s2-s6-swiper .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    autoplay: {
      delay: 3000,
    },
    loop: true,
    speed: 1000,
    effect: 'fade',
    slidesPerView: 1,
    navigation: false,
  });

  // SEC 3
  gsap.set('.co-process-s3-frame .z-ani-o', { opacity: 0, y: 40 });
  let cPS3Tl1 = gsap.timeline({ paused: true });
  cPS3Tl1.to('.co-process-s3-frame .z-ani-o', {
    y: 0,
    scale: 1,
    opacity: 1,
    duration: 1,
    stagger: 0.2,
    ease: "power2.inOut"
  }, "-=0.9");
  ScrollTrigger.create({
    trigger: '.co-process-s3-frame .z-ani-o',
    start: "40% bottom",
    end: "bottom top",
    animation: cPS3Tl1
  });

  //Simple Accordion
  var coAccItems = document.querySelectorAll(".co-process-s3-item--title");
  var coAccItemsWrapp = document.querySelectorAll(".co-process-s3-item");
  // Hide the next sibling element for each item (the content associated with the title)
  coAccItems.forEach(function (groupItem, index) {
    var nextElement = groupItem.nextElementSibling;
    if (index === 0 || groupItem.classList.contains("active")) {
      groupItem.classList.add("active");
      nextElement.classList.add("active");

      gsap.to(nextElement, {
        height: "auto",
        duration: 0.3,
        ease: "power2.inOut",
      });
    } else {
      nextElement.classList.remove("active");
      gsap.to(nextElement, {
        height: 0,
        duration: 0.3,
        ease: "power2.inOut",
      });
    }

    // Add a click event listener to each item
    groupItem.addEventListener("click", function (e) {
      e.preventDefault();
      // Check if the parent element already has the 'active' class
      if (!this.classList.contains("active")) {
        // If not active, hide all other sections
        // coAccItems.forEach(function (otherAccItem, otherIndex) {
        //   otherAccItem.classList.remove("active");
        //   otherAccItem.nextElementSibling.classList.remove("active");

        //   gsap.to(otherAccItem.nextElementSibling, {
        //     height: 0,
        //     duration: 0.3,
        //     ease: "power2.inOut",
        //   });
        // });
        // Add 'active' class to the clicked item and show its content
        this.classList.add("active");
        nextElement.classList.add("active");
        gsap.to(nextElement, {
          height: "auto",
          duration: 0.3,
          ease: "power2.inOut",
        });
      } else {
        // remove 'active' if clicked on 'active'
        this.classList.remove("active");
        nextElement.classList.remove("active");
        gsap.to(nextElement, {
          height: 0,
          duration: 0.3,
          ease: "power2.inOut",
        });
      }
      // If already active, don't hide the content
    });


  });

  coAccItemsWrapp.forEach(function (item, index) {
    if (index >= 6) {
      item.classList.add('hidden');
    }
  });

  coBtnMore = document.querySelector('.co-process-s3-btn-more');
  coBtnMore.addEventListener('click', function (e) {
    e.preventDefault();
    coAccItemsWrapp.forEach(function (item, index) {
      item.style.animationDelay = '0.1' + index * 10 + 's';
      item.classList.remove('hidden');
      item.classList.add('visible');
      coBtnMore.style.display = 'none';
    });
  });


  //SEC 4
  gsap.set('.co-process-s4-parallax', { top: "-20%", height: "120%" });
  gsap.to('.co-process-s4-parallax', { 
    scrollTrigger: {
      trigger: '.co-process-s4',
      start: "top bottom",
      end: "bottom top",
      scrub: true,
    },
    top: "0%"
  });
  gsap.set('.co-process-s4 .z-ani-o', { opacity: 0, y: 40 });
  let cPS4Tl1 = gsap.timeline({ paused: true });
  cPS4Tl1.to('.co-process-s4 .z-ani-o', {
    y: 0,
    scale: 1,
    opacity: 1,
    duration: 1,
    stagger: 0.2,
    ease: "power2.inOut"
  }, "-=0.9");
  ScrollTrigger.create({
    trigger: '.co-process-s4 .z-ani-o',
    start: "40% bottom",
    end: "bottom top",
    animation: cPS4Tl1
  });

});



//CARDS SCROLL

const contentElements = [...document.querySelectorAll('.co-process-s2-section--wrapper')];
const totalContentElements = contentElements.length;

const scrollCards = () => {
  contentElements.forEach((el, position) => {

    const isLast = position === totalContentElements - 1;

    gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: 'center center',
        end: '+=150%',
        scrub: true
      }
    })
      .to(el, {
        ease: 'none',
        scale: 0.8,
        opacity: 1,
        yPercent: 0
      }, 0);

  });
};

// Initialization function
const initCards = () => {
  scrollCards(); // Apply scroll-triggered animations
};